<template>
  <div v-if="mesFacturacion">
    <v-container fluid grid-list-xs>
      <v-layout>
        <v-flex xs5>
          <CampoSelect
            id="btnAñadirPS"
            v-model="idToAdd"
            :items="data"
            texto="nombre"
            disableItem="selected"
            valor="id"
            placeholder="Seleccionar"
            :label="
              $t('message.tasas.periodo.nombre' + this.data[0].tipoTasa + data[0].tipoEmpresa)
            "
          ></CampoSelect>
        </v-flex>
        <v-flex xs5>
          <Boton id="btnSelecPeriodo" tipo="warning" :onclick="addClickHandler"
            >Añadir
            {{ $t('message.tasas.periodo.nombre' + data[0].tipoTasa + data[0].tipoEmpresa) }}</Boton
          >
        </v-flex>
      </v-layout>
      <v-layout row xs12 wrap v-if="periodosSelected.length > 0">
        <v-data-table :id="id" :headers="fields" :items="periodosSelected" hide-actions>
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ props.item.nombre }}</td>
            <td class="text-xs-center">{{ props.item.periodoConsumo | moment('DD-MMMM-YYYY') }}</td>
            <td class="text-xs-right">
              <Numeric id="facturacion" v-model="props.item.facturacion" :readonly="true"></Numeric>
            </td>
            <td class="text-xs-center">
              <Icono
                :id="'editar' + props.item.id"
                :payload="props.item"
                color="info"
                class="mr-2"
                @click="editClick"
                >edit</Icono
              >
              <Icono
                :id="'eliminar' + props.item.id"
                :payload="props.item"
                color="error"
                @click="removeClick"
                >delete</Icono
              >
            </td>
          </template>
          <!-- Footer -->
          <template slot="footer">
            <td class="text-xs-left total"><strong>Total</strong></td>
            <td class="text-xs-center"></td>
            <td class="text-xs-right total" total>
              <Numeric id="totalfacturacion" :value="totalFacturacion" readonly></Numeric>
            </td>
            <td class="text-xs-right"></td>
          </template>
        </v-data-table>
      </v-layout>
    </v-container>
    <!-- Info modal -->
    <Modal id="modalPeriodo" :modalShow="modalShow" size="1000" title="Modificar Suministro">
      <PeriodoConsumo
        :model="rowSelected"
        :mesFacturacion="mesFacturacion"
        @modify="modificarHandler"
        @cancel="cancelarHandler"
      ></PeriodoConsumo>
    </Modal>
  </div>
</template>

<script>
import { Numeric, Boton, Modal, CampoSelect, Icono } from '@/components';
import PeriodoConsumo from './PeriodoConsumo.vue';
import { notificarWarning } from '@/utils/notification';

export default {
  name: 'PeriodosConsumo',
  props: {
    id: {
      type: String,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    mesFacturacion: {
      type: Date
    },
    allowEdit: {
      type: Boolean,
      required: true
    }
  },
  components: {
    Boton,
    PeriodoConsumo,
    Modal,
    Numeric,
    CampoSelect,
    Icono
  },
  data() {
    // Fields a mostrar
    let fields = [];
    fields = [
      {
        value: 'nombre',
        text: this.$t(
          'message.tasas.periodo.nombre' + this.data[0].tipoTasa + this.data[0].tipoEmpresa
        ),
        align: 'left',
        sortable: false
      },
      {
        value: 'periodo',
        text: this.$t('message.tasas.periodo.periodo'),
        align: 'center',
        sortable: false
      },
      {
        value: 'facturacion',
        text: this.$t('message.tasas.periodo.facturacion'),
        align: 'right',
        sortable: false
      },
      {
        value: 'actions',
        text: this.$t('message.tasas.periodo.actions'),
        align: 'center',
        sortable: false
      }
    ];

    return {
      idToAdd: '',
      rowSelected: {},
      modalShow: false,
      fields: fields
    };
  },
  computed: {
    visibleSelect() {
      return this.data.filter(item => !item.selected).length > 0;
    },
    periodosSelected() {
      return this.data.filter(item => item.selected);
    },
    totalFacturacion() {
      var total = 0;
      for (var i in this.data.filter(item => item.selected).map(item => item.facturacion)) {
        total += this.data.filter(item => item.selected).map(item => item.facturacion)[i];
      }
      return total;
    }
  },
  methods: {
    //Pantalla modal
    addClickHandler() {
      if (!this.allowEdit) {
        notificarWarning(this, 'Aviso', 'Por favor, elija primero el mes de facturación');
        return;
      }

      if (!this.idToAdd) {
        notificarWarning(
          this,
          'Aviso',
          'Por favor, seleccione un ' +
            this.$t(
              'message.tasas.periodo.nombre' + this.data[0].tipoTasa + this.data[0].tipoEmpresa
            )
        );
        return;
      }
      //Seleccionamos la fila y la editamos
      this.rowSelected = this.data.find(item => item.id === this.idToAdd);
      this.modalShow = true;
    },
    modificarHandler(payload) {
      this.$emit('modify', payload);
      this.rowSelected = {};
      this.idToAdd = '';
      this.modalShow = false;
    },
    cancelarHandler() {
      this.modalShow = false;
    },
    editClick(item) {
      this.rowSelected = item;
      this.modalShow = true;
    },
    removeClick(item) {
      this.$emit('remove', item);
    }
  }
};
</script>
